import * as actions from './actions';
import { ActionType, getType } from 'typesafe-actions';
import { controlActions } from '../PagesHistory/AuditLog/actions';
import * as historyActions from '../PagesHistory/actions';

export interface AppState {
  readonly appStatus: string;
  readonly isOnline: boolean;
}

const initialState: AppState = {
  appStatus: 'offline',
  isOnline: false,
};

type AppActions = ActionType<typeof actions> & ActionType<typeof controlActions> & ActionType<typeof historyActions>;

export default (state: Mutable<AppState> = initialState, action: AppActions): AppState => {
  switch (action.type) {
    case getType(actions.appGoOnline): {
      state.appStatus = 'online';
      state.isOnline = true;
      break;
    }
    case getType(actions.appGoOffline): {
      state.appStatus = 'offline';
      state.isOnline = false;
      break;
    }
    case getType(controlActions.startAppSync): {
      state.appStatus = 'syncing';
      break;
    }
    case getType(controlActions.appSyncSuccess): {
      state.appStatus = 'online';
      break;
    }
    case getType(controlActions.appSyncError): {
      if (state.isOnline) {
        state.appStatus = 'syncFailed';
      } else {
        state.appStatus = 'offline';
      }
      break;
    }
    case getType(historyActions.fetchPagesHistory.request): {
      state.appStatus = 'syncing';
      break;
    }
    case getType(historyActions.fetchPagesHistory.success): {
      state.appStatus = 'online';
      break;
    }
    case getType(historyActions.fetchPagesHistory.failure): {
      if (state.isOnline) {
        state.appStatus = 'syncFailed';
      } else {
        state.appStatus = 'offline';
      }
      break;
    }
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/containers/App/reducer.ts